// // Action Constants
// export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
// export const UPDATE_DESIGN_SPECIFICATION = 'UPDATE_DESIGN_SPECIFICATION';

// // Attributes
// export const JOB_NAME = 'JOB_NAME';
// export const CUSTOMER_NAME = 'CUSTOMER_NAME';
// export const FIRST_NAME = 'FIRST_NAME';
// export const LAST_NAME = 'LAST_NAME';
// export const PHONE_NUMBER = 'PHONE_NUMBER';
// export const EMAIL = 'EMAIL';

import { fetchTimeout, mergeDeep, deepCopy } from "../components/Common";
import { API_BASE } from "../AppConfig";

export const JOIN_TYPE = {
    // matched to VQU
    DESCRIPTION: "description",
    DEFAULT_OFFSET: "default_offset",
    SHOW_OFFSET: "show_offset",
    DEFAULT_ANGLE: "default_angle",
    SHOW_ANGLE: "show_angle",
    THUMBNAIL: "thumbnail",
};

export const JOIN_TYPES = {
    Offset: {
        description: "Straight",
        default_offset: 0,
        show_offset: true,
        show_area_overlap: true,
        default_angle: 0,
        show_angle: false,
        flat_to_flat: true,
        flat_to_gable: true,
        flat_to_portal: true,
        portal_to_portal: true,
        thumbnail:
            "data:image/gif;base64,R0lGODlhQABAALMAAAA0Zf8A/////////////////////////////////////////////////////////yH5BAEAAAEALAAAAABAAEAAAASqMMhJq7046827/2AojmRpnmiqrmxLAnAsz3Rt33SH73w/676g8McZGoXAoxKXXDqJm6dU5qpQq6wrVqXdorpeEzj8ipG/5rM4rS7D2qUx3COfF9n2Tz2f2fMvfn9WeIIagYUSh4iKhYyCjn+QfJJ5lHZTliCYhC6bb16eAGGho56lm6eZZzWIfTmtgK+wg1CzE6ygprmou5ipU79SwU/DTrbHyMnKy8wrEQAAOw==",
    },
    Angle: {
        description: "Mitre Join",
        default_offset: 0,
        show_offset: false,
        default_angle: 90,
        show_angle: true,
        flat_to_flat: true,
        flat_to_gable: false,
        flat_to_portal: false,
        portal_to_portal: false,
        thumbnail:
            "data:image/gif;base64,R0lGODlhQABAALMAAAA0Zf8A/////////////////////////////////////////////////////////yH5BAEAAAEALAAAAABAAEAAAAT2MMhJq704682710AoAh83iuV1him4ttVKwupLS/Jt5TqvTz5a8DdsFW/HUhK29DRTT5Pth5sKrUSsUYvkKr1MsFMMJUtPHZnavIkG1nBWjx2Pz9HnurqLb+vhV30uf2thghmEdmWHVG97iyONO48fboZsQJiXjIiam5FpnluUg6CSNW6Wd2aqq5wUra6mqLOnGIW3orIoua+2sKTAvr+ZR7GNuMK1xL1Yx8jJjsPMxVbPksnX2I/a2znd3nrUX3/j5HXm54Dplejs7evvY9GdifaJoff67n77/sHN/gmU02/gwHwGBSJM6E+ew4cQI0qcSLEihwgAADs=",
    },
    L1: {
        description: "L-Shape 1",
        default_offset: 0,
        show_offset: false,
        default_angle: 90,
        show_angle: false,
        flat_to_flat: true,
        flat_to_gable: false,
        flat_to_portal: true,
        portal_to_portal: false,
        thumbnail:
            "data:image/gif;base64,R0lGODlhQABAALMAAAA0Zf8A/////////////////////////////////////////////////////////yH5BAEAAAEALAAAAABAAEAAAATMMMhJq704682710AoAh83iuV1him4ttVKwupLS/Jt5TqvTz5a8DdsFW/HUhK29DRTT5Pth5sKrUSsUYvkKr1MsFMMJUtPHZl6zW6bA+643J2e2++sM37frvP/an6Agyh6hINUiRhRimFojZBwb5EfjJRjj5dUlpobnJ0Zn6A1maOOI6Zdpalfq6yYqK9lrrKek7VVtLiLt7iisr+vwazDqcWmx6PJoMudzZrPl4yH1ILUf9bXe9nad9zdc9/gceLjfbvo6err7O3uKREAADs=",
    },
    L2: {
        description: "L-Shape 2",
        default_offset: 0,
        show_offset: false,
        default_angle: 90,
        show_angle: false,
        flat_to_flat: true,
        flat_to_gable: false,
        flat_to_portal: true,
        portal_to_portal: false,
        thumbnail:
            "data:image/gif;base64,R0lGODlhQABAALMAAAA0Zf8A/////////////////////////////////////////////////////////yH5BAEAAAEALAAAAABAAEAAAAT+MMhJq704682710AoAh83iuV1him4ttVKwupLS/Jt5TqvTz5a8DdsFW/HUhK29DRTT5Pth5sKrUSsUYvkKr1MsFMMJUtPHZnavIkG1nBWjx2HZ9HnOtuFb+vdfCNpf3sZboSFGICDfVeNd4Jzj5KRXZOWlY6ZkCiUnVRviTWXmp+lcqCLiqKBpmGkr5tbsLOyZbS3tl+4u7ofqn68wb61rsWoVMA7rIbMFMrNwq3InNTHM6nOQNrL0tHEucbh1pjiveax6GPeeeqM4Ofk8djJ3KHsw+7t8jGI/v7v/gm0s2+gQXj3DirUl3ChwoAODUKMKBCUxYsYM2rcyLGjx48EIKlEAAA7",
    },
    Hip: {
        description: "Hip Junction",
        default_offset: 0,
        show_offset: false,
        default_angle: 90,
        show_angle: false,
        flat_to_flat: false,
        flat_to_gable: false,
        flat_to_portal: false,
        portal_to_portal: true,
        thumbnail:
            "data:image/gif;base64,R0lGODlhQABAALMAAAA0Zf8A/////////////////////////////////////////////////////////yH5BAEAAAEALAAAAABAAEAAAAT+MMhJq704682710AoAh83imCYnuV2qhkav+06rrZcXy85+5jeLkj75WDDitD4uyWVRSKQF31KltLj1IqlbqEs66Rr0Xmd4gAZrE1fq2Xk2cyFs5v055qS59vnPYFffoNjf3GCiTh4coyJYVmOHY+KTFJoWpSNd5d9iJqQXm0moHtvhaeYbqmRnZurqqejq2Bfnqm3bnm5prR0vIe+ZsChtLWGqGrBxk7EscaEJM650L3KxdCfr8jP2dHJ1tylpbOZ45WuyeLnmpLepNvh76za2/Oc3/b3hPXq+9db5P3DJHCgjoIGYSBMKG3ZP0QAqT2s5XBivm4WAUmMyK6joEkhHkN+hCey5EaTKPWtS9kRJEuRLl96zEizps2bOHPqnBcBADs=",
    },
    Gable: {
        description: "Gable Junction",
        default_offset: 0,
        show_offset: false,
        default_angle: 90,
        show_angle: false,
        flat_to_flat: false,
        flat_to_gable: false,
        flat_to_portal: false,
        portal_to_portal: true,
        thumbnail:
            "data:image/gif;base64,R0lGODlhQABAALMAAAA0Zf8A/////////////////////////////////////////////////////////yH5BAEAAAEALAAAAABAAEAAAAT+MMhJq704682710AoAh83imCYnuV2qhkav+06rrZcXy85+5jeLkj75WDDitD4uyWVRSKQF31KltLj1IqlbqEs66Rr0Xmd4gAZrE1fq2Xk2cyFs5v055qS59vnPYFffoNjf3GCiTh4coyJYVmOHY+KTFJoWpSNd5d9iJqHapuGoYSgh32VbmCbeY+rc5xvqrCshKYke7WiSDJFurssKFHAwZq4o7vImLPMyp/OvNHPyJ3J1KSF0p7YH8XdJqXZp+Tkk+Xop+fp7LTgLd/vkvI18fTQ1/fW2vqA/P2suAEMmG/guIIGtyE0aG9gQ4D22kkMtG6ixX/NLkqsqLEdx44T6T6CLCdypLqEKFOqXMmyZcIIAAA7",
    },
    None: {
        description: "None",
        default_offset: 0,
        show_offset: false,
        default_angle: 0,
        show_angle: false,
        flat_to_flat: true,
        flat_to_gable: true,
        flat_to_portal: true,
        portal_to_portal: true,
        thumbnail:
            "data:image/gif;base64,R0lGODlhQABAALMAAAA0Zf8A/////////////////////////////////////////////////////////yH5BAEAAAEALAAAAABAAEAAAATEMMhJq7046827/2AojmRpnmiqrmxLAnAsz/Qc1Hje5Xx998AdcPgb6jjGYPK4WfKKTpkwSoNSAdNrzEp1VaRS7wm8FZvIMPN5G1aP0Fj3m12Wh+B2ET4P2vM9fn9IdGmCWVCGh22JGYGMF46PX4RxkpCUlhiRmYiLnBKbmaGWo5Klj6eMcFduq11qrlGtlKywtK9msU6zaVp1Yp6fk4XCl8TFw5XIFMHLzV6+zy7Rv7bUedTH1tHY2d3Xy+Hi4+Tl5h8RAAA7",
    },
};

export const JOIN_TYPES_LYSAGHT = {
    Offset: {
        description: "Straight",
        default_offset: 0,
        show_offset: true,
        show_area_overlap: true,
        default_angle: 0,
        show_angle: false,
        flat_to_flat: true,
        flat_to_gable: true,
        flat_to_portal: true,
        portal_to_portal: true,
        thumbnail:
            "data:image/gif;base64,R0lGODlhQABAALMAAAA0Zf8A/////////////////////////////////////////////////////////yH5BAEAAAEALAAAAABAAEAAAASqMMhJq7046827/2AojmRpnmiqrmxLAnAsz3Rt33SH73w/676g8McZGoXAoxKXXDqJm6dU5qpQq6wrVqXdorpeEzj8ipG/5rM4rS7D2qUx3COfF9n2Tz2f2fMvfn9WeIIagYUSh4iKhYyCjn+QfJJ5lHZTliCYhC6bb16eAGGho56lm6eZZzWIfTmtgK+wg1CzE6ygprmou5ipU79SwU/DTrbHyMnKy8wrEQAAOw==",
    },
    Angle: {
        description: "Mitre Join",
        default_offset: 0,
        show_offset: false,
        default_angle: 90,
        show_angle: true,
        flat_to_flat: true,
        flat_to_gable: false,
        flat_to_portal: false,
        portal_to_portal: false,
        thumbnail:
            "data:image/gif;base64,R0lGODlhQABAALMAAAA0Zf8A/////////////////////////////////////////////////////////yH5BAEAAAEALAAAAABAAEAAAAT2MMhJq704682710AoAh83iuV1him4ttVKwupLS/Jt5TqvTz5a8DdsFW/HUhK29DRTT5Pth5sKrUSsUYvkKr1MsFMMJUtPHZnavIkG1nBWjx2Pz9HnurqLb+vhV30uf2thghmEdmWHVG97iyONO48fboZsQJiXjIiam5FpnluUg6CSNW6Wd2aqq5wUra6mqLOnGIW3orIoua+2sKTAvr+ZR7GNuMK1xL1Yx8jJjsPMxVbPksnX2I/a2znd3nrUX3/j5HXm54Dplejs7evvY9GdifaJoff67n77/sHN/gmU02/gwHwGBSJM6E+ew4cQI0qcSLEihwgAADs=",
    },
    L1: {
        description: "L-Shape 1",
        default_offset: 0,
        show_offset: false,
        default_angle: 90,
        show_angle: false,
        flat_to_flat: true,
        flat_to_gable: false,
        flat_to_portal: true,
        portal_to_portal: false,
        thumbnail:
            "data:image/gif;base64,R0lGODlhQABAALMAAAA0Zf8A/////////////////////////////////////////////////////////yH5BAEAAAEALAAAAABAAEAAAATMMMhJq704682710AoAh83iuV1him4ttVKwupLS/Jt5TqvTz5a8DdsFW/HUhK29DRTT5Pth5sKrUSsUYvkKr1MsFMMJUtPHZl6zW6bA+643J2e2++sM37frvP/an6Agyh6hINUiRhRimFojZBwb5EfjJRjj5dUlpobnJ0Zn6A1maOOI6Zdpalfq6yYqK9lrrKek7VVtLiLt7iisr+vwazDqcWmx6PJoMudzZrPl4yH1ILUf9bXe9nad9zdc9/gceLjfbvo6err7O3uKREAADs=",
    },
    L2: {
        description: "L-Shape 2",
        default_offset: 0,
        show_offset: false,
        default_angle: 90,
        show_angle: false,
        flat_to_flat: true,
        flat_to_gable: false,
        flat_to_portal: true,
        portal_to_portal: false,
        thumbnail:
            "data:image/gif;base64,R0lGODlhQABAALMAAAA0Zf8A/////////////////////////////////////////////////////////yH5BAEAAAEALAAAAABAAEAAAAT+MMhJq704682710AoAh83iuV1him4ttVKwupLS/Jt5TqvTz5a8DdsFW/HUhK29DRTT5Pth5sKrUSsUYvkKr1MsFMMJUtPHZnavIkG1nBWjx2HZ9HnOtuFb+vdfCNpf3sZboSFGICDfVeNd4Jzj5KRXZOWlY6ZkCiUnVRviTWXmp+lcqCLiqKBpmGkr5tbsLOyZbS3tl+4u7ofqn68wb61rsWoVMA7rIbMFMrNwq3InNTHM6nOQNrL0tHEucbh1pjiveax6GPeeeqM4Ofk8djJ3KHsw+7t8jGI/v7v/gm0s2+gQXj3DirUl3ChwoAODUKMKBCUxYsYM2rcyLGjx48EIKlEAAA7",
    },
    None: {
        description: "None",
        default_offset: 0,
        show_offset: false,
        default_angle: 0,
        show_angle: false,
        flat_to_flat: true,
        flat_to_gable: true,
        flat_to_portal: true,
        portal_to_portal: true,
        thumbnail:
            "data:image/gif;base64,R0lGODlhQABAALMAAAA0Zf8A/////////////////////////////////////////////////////////yH5BAEAAAEALAAAAABAAEAAAATEMMhJq7046827/2AojmRpnmiqrmxLAnAsz/Qc1Hje5Xx998AdcPgb6jjGYPK4WfKKTpkwSoNSAdNrzEp1VaRS7wm8FZvIMPN5G1aP0Fj3m12Wh+B2ET4P2vM9fn9IdGmCWVCGh22JGYGMF46PX4RxkpCUlhiRmYiLnBKbmaGWo5Klj6eMcFduq11qrlGtlKywtK9msU6zaVp1Yp6fk4XCl8TFw5XIFMHLzV6+zy7Rv7bUedTH1tHY2d3Xy+Hi4+Tl5h8RAAA7",
    },
};

export const ATTACHMENT_TYPE_TEMPLATE = () => {
    return {
        "Fascia with Receiver Channel": {
            display_name: "Fascia with Receiver Channel",
            old_key: "Timber Fascia Drop",
            has_beam: false,
            has_backchannel: true,
            to_wall: false,
            bracket_type_desc: "R/C w/ CON110",
            bracket_type_code: window.LYSAGHT
                ? {
                      default: "CON110",
                  }
                : {
                      default: "BK26DEG",
                  },
            bracket_spacing_tile: 600,
            bracket_spacing_sheet: 900,
            depth_offset_default: 0,
            depth_offset_editable: false,
            height_offset_default: "-Sheet_Height",
            height_offset_editable: false,
            height_offset_editable_side: true,
            height_offset_min: -1000,
            height_offset_max: 1000,
            height_offset_label: "Fascia Height Below Pitching Height",
            items_for_bom: {},
            allow_for_gable: false,
            allow_for_gable_side: false,
            allow_for_watershed_side: false,
            allow_on_side: true,
            wall_thickness: 110 + 40,
            variations: {
                "Timber Fascia": {
                    fascia_type: "Timber Fascia",
                    old_key: "Timber Fascia Drop",
                    items_for_bom: {},
                },
                "Steel Fascia": {
                    fascia_type: "Steel Fascia",
                    old_key: "Metal Fascia Drop",
                    items_for_bom: {},
                },
            },
        },
        "Rafter Brackets supporting Beam": {
            display_name: "Rafter Brackets supporting Beam",
            old_key: "Beam",
            has_beam: true,
            has_backchannel: false,
            to_wall: false,
            // has_gutter: false,
            bracket_type_desc: "UCEG",
            bracket_type_code: window.LYSAGHT
                ? {
                      default: "UCF",
                      FL15015: "UCF",
                      FL20020: "UCH",
                  }
                : {
                      default: "BK34<R1>G",
                  },
            beam_attachment_blocking: "",
            bracket_spacing_tile: 1200,
            bracket_spacing_sheet: 900,
            depth_offset_default: 160,
            depth_offset_max: 300,
            depth_offset_min: 100,
            depth_offset_editable: false,
            height_offset_default: "Beam_Height",
            height_offset_max: 500,
            height_offset_min: "Beam_Height",
            height_offset_editable: false,
            items_for_bom: {},
            allow_for_gable: true,
            allow_for_watershed_side: true,
            allow_on_side: true,
            wall_thickness: 110 + 40 + 90,
            rSBLC_option: true,
            variations: {
                Gutter: {
                    fascia_type: "Gutter",
                    // has_gutter: true,
                    depth_offset_default: 300,
                    depth_offset_max: 300,
                    depth_offset_min: 300,
                    height_offset_default: "Beam_Height-50",
                    height_offset_max: 500,
                    // height_offset_min: "Beam_Height",
                    height_offset_min: 0,
                    height_offset_editable: false,
                    height_offset_editable_side: true,
                    items_for_bom: {},
                },
                "On Riser": {
                    fascia_type: "On Riser",
                    old_key: "Riser",
                    bracket_type_code: window.LYSAGHT
                        ? {
                              default: "UCB",
                          }
                        : {
                              default: "BK34<R1>G",
                          },
                    depth_offset_default: "150-Beam_Width",
                    depth_offset_max: "150-Beam_Width",
                    depth_offset_min: "150-Beam_Width",
                    depth_offset_editable: false,
                    height_offset_max: 500,
                    height_offset_default: 500,
                    height_offset_min: 350,
                    height_offset_label: "Riser Height From Area Height",
                    height_offset_editable: true,
                    height_offset_editable_side: true,
                    items_for_bom: {},
                },
            },
        },
        Flyover: {
            display_name: "Flyover",
            old_key: "Flyover",
            has_beam: true,
            has_backchannel: false,
            to_wall: false,
            bracket_type_code: {
                default: "JMBP1",
            },
            // bracketTypeDesc: "JMBP1", automatic for flyover
            // bracketTypeCode: "JMBP1",
            bracket_spacing_tile: "FlyoverBracketSpacing",
            bracket_spacing_sheet: "FlyoverBracketSpacing",
            depth_offset_default: -1000,
            depth_offset_max: 0,
            depth_offset_min: -2000,
            depth_offset_editable: false,
            height_offset_default: "Beam_Height",
            height_offset_max: "Flyover",
            height_offset_default: 800,
            height_offset_min: "Flyover",
            height_offset_editable: true,
            allow_for_watershed_side: true,
            allow_on_side: true,
            allow_for_gable_side: false,
            allow_for_gable: false,
            items_for_bom: {},
            wall_thickness: 110 + 40 + 90,
            wall_type: "Brick",
            // variations: {
            //     "Brick Veneer": {
            //         wall_type: "Brick",
            //         wall_thickness: 110 + 40 + 90,
            //     },
            //     "Timber Frame": {
            //         wall_type: "Timber Frame",
            //         wall_thickness: 90,
            //     },
            // },
        },
        "Wall with Receiver Channel": {
            display_name: "Wall with Receiver Channel",
            old_key: "Wall",
            has_beam: false,
            has_backchannel: true,
            to_wall: true,
            has_gutter: false,
            wall_only: true,
            has_rafter_brackets: false,
            depth_offset_default: 0,
            depth_offset_editable: false,
            height_offset_default: "-Sheet_Height",
            height_offset_editable: false,
            bracketType: "R/C w/ Coach Screws",
            bracketCode: "CS7510G",
            bracket_type_code: window.LYSAGHT
                ? {
                      default: "UCF",
                      FL15015: "UCF",
                      FL20020: "UCH",
                  }
                : {
                      default: "BK29",
                  },
            bracket_spacing_tile: 600,
            bracket_spacing_sheet: 600,
            items_for_bom: {},
            allow_for_gable: false,
            allow_for_gable_side: false,
            allow_for_watershed_side: false,
            allow_on_side: true,
            wall_thickness: 110 + 40 + 90,
            variations: {
                "Masonry Wall": {
                    wall_type: "Brick",
                    wall_thickness: 110 + 40 + 90,
                    items_for_bom: {},
                },
                "Masonry Wall With Beam": {
                    wall_type: "Brick",
                    has_beam: true,
                    wall_thickness: 110 + 40 + 90,
                    items_for_bom: {},
                },
                "Timber Wall": {
                    wall_type: "Timber Frame",
                    wall_thickness: 90,
                    items_for_bom: {},
                },
                "Timber With Beam": {
                    wall_type: "Timber Frame",
                    has_beam: true,
                    wall_thickness: 90,
                    items_for_bom: {},
                },
            },
        },
        "Wall with Offset Brackets Supporting Gutter and Beam": {
            display_name: "Wall w/Offset Brackets, Gutter & Beam",
            old_key: "Wall",
            has_beam: true,
            has_gutter: true,
            has_backchannel: false,
            to_wall: true,
            wall_only: true,
            depth_offset_default: 150,
            depth_offset_editable: false,
            height_offset_default: "Beam_Height+100",
            // height_offset_default: 0,
            height_offset_editable: false,
            allow_for_gable: true,
            allow_for_gable_side: true,
            allow_for_watershed_side: true,
            bracket_type_code: window.LYSAGHT
                ? {
                      default: "UCF",
                      FL15015: "UCF",
                      FL20020: "UCH",
                  }
                : {
                      default: "BK29",
                  },
            bracket_description: "Offset Brackets Supporting Beam",
            bracket_spacing_tile: 1200,
            bracket_spacing_sheet: 1200,
            allow_on_side: true,
            items_for_bom: {},
            variations: {
                "Brick Veneer": {
                    wall_type: "Brick",
                    bracket_description: "Offset Brackets to Masonry",
                    wall_thickness: 110 + 40 + 90,
                    items_for_bom: {},
                },
                "Brick Veneer, Beam on Riser": {
                    wall_type: "Brick",
                    bracket_description: "Offset Brackets to Masonry, Beam on Riser",
                    height_offset_max: 500,
                    height_offset_default: 500,
                    height_offset_min: 250,
                    height_offset_label: "Riser Height From Area Height",
                    height_offset_editable: true,
                    height_offset_editable_side: true,
                    wall_thickness: 110 + 40 + 90,
                    items_for_bom: {},
                    bracket_type_desc: window.LYSAGHT
                        ? "UCB Riser on Offset Brackets"
                        : "BK39 Riser on Offset Brackets",
                    bracket_type_code: window.LYSAGHT
                        ? {
                              default: "UCB",
                              FL15015: "UCB",
                              FL20020: "UCB",
                          }
                        : {
                              default: "BK39",
                          },
                },
                "Timber Frame": {
                    wall_type: "Timber Frame",
                    bracket_description: "Offset Brackets to Timber Frame",
                    wall_thickness: 90,
                    items_for_bom: {},
                },
                "Timber Frame, Beam on Riser": {
                    wall_type: "Timber Frame",
                    bracket_description: "Offset Brackets to Timber Frame, Beam on Riser",
                    height_offset_max: 500,
                    height_offset_default: 500,
                    height_offset_min: 250,
                    height_offset_label: "Riser Height From Area Height",
                    height_offset_editable: true,
                    height_offset_editable_side: true,
                    wall_thickness: 90,
                    items_for_bom: {},
                    bracket_type_desc: window.LYSAGHT
                        ? "UCB Riser on Offset Brackets"
                        : "BK39 Riser on Offset Brackets",
                    bracket_type_code: window.LYSAGHT
                        ? {
                              default: "UCB",
                              FL15015: "UCB",
                              FL20020: "UCB",
                          }
                        : {
                              default: "BK39",
                          },
                },
            },
        },
        Wall: {
            display_name: "Wall",
            old_key: "Wall",
            has_beam: false,
            has_backchannel: false,
            to_wall: true,
            has_gutter: false,
            wall_only: true,
            has_rafter_brackets: false,
            depth_offset_default: 0,
            depth_offset_editable: false,
            height_offset_default: "-Sheet_Height",
            height_offset_editable: false,
            bracketType: "Coach Screws @ 450 cts",
            bracket_type_desc: "R/C w/ CON110",
            bracketCode: "CS7510G",
            bracket_type_code: {
                default: "",
            },
            bracket_spacing_tile: 600,
            bracket_spacing_sheet: 600,
            items_for_bom: {},
            allow_for_flat: false,
            allow_for_gable: false,
            allow_for_gable_side: true,
            allow_for_watershed_side: false,
            deck_only: true,
            allow_on_side: true,
            wall_thickness: 110 + 40 + 90,
            variations: {
                "Masonry Wall With Beam": {
                    wall_type: "Brick",
                    bracket_type_desc: "Masonry Anchors @ 450 cts",
                    has_beam: true,
                    wall_thickness: 110 + 40 + 90,
                    items_for_bom: {},
                },
                "Timber With Beam": {
                    wall_type: "Timber Frame",
                    bracket_type_desc: "Coach Screws @ 450 cts",
                    has_beam: true,
                    wall_thickness: 90,
                    items_for_bom: {},
                },
            },
        },
        // "Not Attached": {
        //     display_name: "Not Attached (But Show House)",
        //     has_beam: false,
        //     has_backchannel: false,
        //     to_wall: false,
        //     bracket: "CON110",
        //     bracketUse: "XYZ",
        //     beam_attachment_blocking: "",
        //     bracket_spacing_tile: 1200,
        //     bracket_spacing_sheet: 900,
        //     depth_offset_default: 0,
        //     depth_offset_max: 900,
        //     depth_offset_min: -900,
        //     depth_offset_editable: true,
        //     height_offset_default: "-Sheet_Height",
        //     height_offset_max: 1000,
        //     height_offset_min: -1000,
        //     height_offset_editable: true,
        //     allow_for_gable: true,
        //     items_for_bom: {},
        //     allow_for_watershed_side: true,
        //     allow_on_side: true,
        //     wall_thickness: 110 + 40 + 90,
        //     variations: {
        //         "Timber Fascia": {
        //             fascia_type: "Timber Fascia",
        //             items_for_bom: {},
        //         },
        //         "Steel Fascia": {
        //             fascia_type: "Steel Fascia",
        //             items_for_bom: {},
        //         },
        //     },
        // },
    };
};

// RoofSheet Specification
export const DESIGN_TYPES = {
    // matched to VQU
    FLAT: "Flat Roof",
    GALV_FLAT: "Galv Flat Roof",
    PITCHED: "Pitched Roof",
    GABLE_PORTAL: "Gable Hip Roof",
    DECK: "Flat Deck",
    LOUVRE: "Louvre Roof",
};
// RoofSheet Specification
export const DESIGN_SUBTYPES = {
    // matched to VQU
    PROJECTION: "Projection",
};

// RoofSheet Specification
export const ROOFSHEET_TYPE = {
    // matched to VQU
    NAME: "name",
    SUBTYPES: "subtypes",
    DEFAULT_SUBTYPE: "default_subtype",
    DEFAULT_COLOUR: "default_colour",
    DEFAULT_SKYLIGHT: "default_skylight",
    THUMBNAIL: "thumbnail",
    TEXTURE_FILENAME: "texture_filename",
    TEXTURE_NORMAL_FILENAME: "texture_normal_filename",
    MIN_PITCH: "min_pitch",
    COLOURS: "colours",
};
// RoofSheet Specification
export const GUTTER_TYPE = {
    // matched to VQU
    NAME: "name",
    DEFAULT_COLOUR: "default_colour",
    THUMBNAIL: "thumbnail",
    COLOURS: "colours",
};
export const DOWNPIPE_TYPE = {
    // matched to VQU
    NAME: "name",
    DEFAULT_COLOUR: "default_colour",
    THUMBNAIL: "thumbnail",
    COLOURS: "colours",
};
export const BEAM_TYPE = {
    // matched to VQU
    NAME: "Name",
    DEFAULT_COLOUR: "default_colour",
    THUMBNAIL: "thumbnail",
    SECTION_DEFAULT: "section_default",
    COLOURS: "colours",
    OPTIONS: "options",
};

// Page Actions
export const UPDATE_ALL = "UPDATE_ALL";

export default function (state = initialState, action) {
    switch (action.type) {
        case UPDATE_ALL:
            return {
                ...action.value,
            };
        default:
            return state;
    }
}

const updateAPP = (parameter, value) => (dispatch) => {
    //
    return new Promise((resolve) => {
        dispatch({
            type: "UPDATE_APP",
            parameter: parameter,
            value: value,
        });
        return resolve(true);
    });
};

export const loadOffering =
    (job = null) =>
    (dispatch, getState) => {
        if (job === null) job = { ...getState().job };
        let app = { ...getState().app };

        let brand = window.brand;
        let region = "";
        let business = "";

        if (job && job.Distributor) {
            brand = job?.Distributor?.Offer?.Brand;
            region = job?.Distributor?.Offer?.Regions[0];
            business = job?.Distributor?.id;
        }
        if (!region) {
            brand = app?.user?.Brand;
            region = app?.user?.BusinessDetails?.Offer?.Regions[0];
            business = app?.user?.BusinessDetails?.id;
        }

        if (!brand) brand = "Fielders";
        if (!region) region = window.LYSAGHT ? "LSB" : "MEN";

        if (!app?.offerings?.[brand]?.Master) return;

        let offering = {
            ...deepCopy(app.offerings[brand].Master),
            validationSchema: {
                ...deepCopy(app?.offerings?.[brand]?.validationSchema),
            },
        };
        let dealer_offering = null;
        if (app?.offerings?.[brand]?.Dealer) dealer_offering = { ...deepCopy(app?.offerings?.[brand]?.Dealer) };

        let job_custom_offering = null;
        if (job?.DesignParameters?.CustomisedOffering)
            job_custom_offering = { ...deepCopy(job?.DesignParameters?.CustomisedOffering) };

        if (region) {
            if (Object.keys(app.offerings[brand].Regions).includes(region)) {
                //offering is the user base business, valid most of the time for most users, offerings should be downloaded already
                offering = mergeDeep(offering, { ...app.offerings[brand].Regions[region] });

                if (dealer_offering) offering = mergeDeep(offering, dealer_offering);
                if (job_custom_offering) offering = mergeDeep(offering, job_custom_offering);
                dispatch(updateConfigAll(offering));
            } else {
                let key = (brand === "Fielders" ? "CEN" : "LLD") + "_OFFERING";
                //need to get it
                fetchTimeout(API_BASE() + "Offering/" + key + "/" + region, {
                    method: "GET", // *GET, POST, PUT, DELETE, etc.
                })
                    .then((res) => res.json())
                    .then((region_data) => {
                        offering = mergeDeep(offering, region_data);

                        if (dealer_offering) offering = mergeDeep(offering, dealer_offering);
                        if (job_custom_offering) offering = mergeDeep(offering, job_custom_offering);
                        dispatch(updateConfigAll(offering));

                        let new_app_offering = { ...app.offerings };
                        new_app_offering[brand].Regions[region] = region_data;
                        if (new_app_offering) dispatch(updateAPP("offerings", new_app_offering));
                    })
                    .catch((e) => {
                        if (dealer_offering) offering = mergeDeep(offering, dealer_offering);
                        if (job_custom_offering) offering = mergeDeep(offering, job_custom_offering);
                        dispatch(updateConfigAll(offering));
                    });
            }
        } else {
            if (dealer_offering) offering = mergeDeep(offering, dealer_offering);
            if (job_custom_offering) offering = mergeDeep(offering, job_custom_offering);
            dispatch(updateConfigAll(offering));
        }
    };

export const updateConfigAll = (config) => (dispatch) => {
    config.attachment_types = mergeDeep(
        ATTACHMENT_TYPE_TEMPLATE(),
        config.attachment_types ? config.attachment_types : {}
    );

    dispatch({
        type: UPDATE_ALL,
        value: config,
    });

    window.config = config;
};

const Box_Beam_Array = {
    656508: {
        name: "65 Box Beam",
        thumbnail:
            "data:image/png;base64,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",
    },
    1086510: {
        name: "108 Box Beam",
        thumbnail:
            "data:image/png;base64,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",
    },
    1586510: {
        name: "158 Box Beam",
        thumbnail:
            "data:image/png;base64,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",
    },
    2086510: {
        name: "208 Box Beam",
        thumbnail:
            "data:image/png;base64,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",
    },
};
const RHS_Beam_Array = {
    "50mm x 50mm x 1.6mm": {
        name: "50mm SHS x 1.6mm (65 Box)",
        thumbnail:
            "data:image/png;base64,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",
    },
    "50mm x 50mm x 2mm": {
        name: "50mm SHS x 2mm (65 Box)",
        thumbnail:
            "data:image/png;base64,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",
    },
    "50mm x 50mm x 2.5mm": {
        name: "50mm SHS x 2.5mm (65 Box)",
        thumbnail: "",
    },
    "50mm x 50mm x 3mm": {
        name: "50mm SHS x 3mm (65 Box)",
        thumbnail: "",
    },
    "50mm x 50mm x 4mm": {
        name: "50mm SHS x 4mm (65 Box)",
        thumbnail: "",
    },
    "50mm x 50mm x 5mm": {
        name: "50mm SHS x 5mm (65 Box)",
        thumbnail: "",
    },
    "100mm x 50mm x 1.6mm": {
        name: "100x50 RHS x 1.6mm (108 Box)",
        thumbnail: "",
    },
    "100mm x 50mm x 2mm": {
        name: "100x50 RHS x 2mm (108 Box)",
        thumbnail: "",
    },
    "100mm x 50mm x 2.5mm": {
        name: "100x50 RHS x 2.5mm (108 Box)",
        thumbnail: "",
    },
    "100mm x 50mm x 3mm": {
        name: "100x50 RHS x 3mm (108 Box)",
        thumbnail: "",
    },
    "100mm x 50mm x 4mm": {
        name: "100x50 RHS x 4mm (108 Box)",
        thumbnail: "",
    },
    "100mm x 50mm x 5mm": {
        name: "100x50 RHS x 5mm (108 Box)",
        thumbnail: "",
    },
    "150mm x 50mm x 2mm": {
        name: "150x50 RHS x 2mm (158 Box)",
        thumbnail: "",
    },
    "150mm x 50mm x 2.5mm": {
        name: "150x50 RHS x 2.5mm (158 Box)",
        thumbnail: "",
    },
    "150mm x 50mm x 3mm": {
        name: "150x50 RHS x 3mm (158 Box)",
        thumbnail: "",
    },
    "150mm x 50mm x 4mm": {
        name: "150x50 RHS x 4mm (158 Box)",
        thumbnail: "",
    },
    "150mm x 50mm x 5mm": {
        name: "150x50 RHS x 5mm (158 Box)",
        thumbnail: "",
    },
};

const RHS_Beam_Array_No_50 = {
    "100mm x 50mm x 1.6mm": RHS_Beam_Array["100mm x 50mm x 1.6mm"],
    "100mm x 50mm x 2mm": RHS_Beam_Array["100mm x 50mm x 2mm"],
    "100mm x 50mm x 2.5mm": RHS_Beam_Array["100mm x 50mm x 2.5mm"],
    "100mm x 50mm x 3mm": RHS_Beam_Array["100mm x 50mm x 3mm"],
    "100mm x 50mm x 4mm": RHS_Beam_Array["100mm x 50mm x 4mm"],
    "100mm x 50mm x 5mm": RHS_Beam_Array["100mm x 50mm x 5mm"],
    "150mm x 50mm x 2mm": RHS_Beam_Array["150mm x 50mm x 2mm"],
    "150mm x 50mm x 2.5mm": RHS_Beam_Array["150mm x 50mm x 2.5mm"],
    "150mm x 50mm x 3mm": RHS_Beam_Array["150mm x 50mm x 3mm"],
    "150mm x 50mm x 4mm": RHS_Beam_Array["150mm x 50mm x 4mm"],
    "150mm x 50mm x 5mm": RHS_Beam_Array["150mm x 50mm x 5mm"],
};

const SHS_PC_Array = {
    "90mm x 90mm x 3.5mm P/C": {
        name: "90mm SHS x 3.5mm P/C",
        thumbnail:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABUBAMAAAD0ee18AAAAK3RFWHRDcmVhdGlvbiBUaW1lAFRodSAzIFNlcCAyMDIwIDE3OjIwOjMxICswOTMwMZUdpAAAAAd0SU1FB+QJAwc3CMU3ACgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAEZ0FNQQAAsY8L/GEFAAAALVBMVEX///////fr7uiMjIRaWlrOzs57e3vW1s6fn5mMjIz39/fW1tYxMTGQkIwYGBBcF8mhAAAAAXRSTlMAQObYZgAABEdJREFUeNrVl81rG0cYhxVDIdBL/wR3iepUIZdMEN1DL8XVpRCK6MSL91Y1Sz8SyEWkNJcgvHiI0Gl68EAWjEhKWQdjBNuC95ychGjrpmhb9mZ6EvM39J3Z2dkPrarVMa+/JPzoxzPvO/vVaGxax3VBd3uDVIt068MYqna4gK264VjSNcOxqlrhWFdrExh3jzeA17dFg2GNcFyq1iYwtrc3gDGerIXtwA5xsCZcw+JXkL4zamgE2cvK8ACvqKr54/6jfmpdwrerkhW1BC+Ht8YwvBJmhyvCHwz8phuGtubgkxlcmj9y3rROQCHUsKgV82e0d7TvN9O0HJzK5cIZY6jn+ifu3q+hhOErCItreD+FySiOaPujfV+AjxM8EOH5RYdnCRyLYuibIagAGGiVINkBOHz0GFvf5uA4Qs7RuWgiMCGW1gKGt+EEQsjveTiOKUJPITw0buBALlZqhMYkwAST34owqKA3vgwPxSEm5xlOAstt2kH/SQJHnoLnowh9nDQxlI2DdRoWce2W/8U9BTNNxyRm0MQxthPcaAYWwbZ//Q5/lcJMw3MC5kfn0ly0gxBrz3hxn3P+mYJNxrQ2IaOIoqEwhx4QGN74gPPFlH/y+VJyUqg9P/dhixM3nNy8A+h0OstgFuns+VwMtP1g8AJbh0bzGefTaQnOwueEkDj2kONaduvuTMbmYXOJJsRD7mDnvootJ+esJTyK3Os8jRXwl9Ww6snwmo6tgsUqPQ3jDxarYN0PL/EeRXs/FeDvCt1gBZH5Rfd5NWxG0iPycuZlONOAWKkR5WD75SpniCz2xPurW4RvKRhRU3WDeVEkXzKzvQpGiDHTiy8gO07g+MLpnq6ATYF7IlqVx0rJ/FbmjARw4UWe5L0oBvi0EqaMUUYRtI7pdXqrYATnAIAhUKhQU+JL8MN0i4I1ld/JGCvg2R/ZfhYaEpa98CJzCR7qZChJir+y46jsPBukzqpfFHnMFObiTNaeFJ0HD1NY4VR9SgyzbZzmNz//54nuhqcwpOA4dlqnuaNqyofZuBGVSMRgmZ6YCgN4MctrnGWwnDdMBaVGAgZGw4fK2empbBZrF5TAs5TmXQXvKlr1jqIsGahEnGMFv/NVp2cqFSFDZRtbxdY1FdzY+rOjvGEyqjFlOEjhRuPuriNhsZ2kOO0ZGp6BOm+eZVfZDxNamIs9TZGTS15wfvl9/oKvxZNl5mE4718aVuHuYOug44gDzBR7KRmKZj/1m6R0K/GLEhfa1PElDLZ88dQfW+5xEW78LDsuPKipFgjs6x8Mo19xu/TubVCBAwem3hMagPJ7/o5VcZd3BX4OpArAoCHQy30/IIfJ/5brJtDAop6Ev/aNwD1rrKyru3KcYj//e+4H7v/fUW/92OmhtnPj5d++v0P2G2sKht92xoaxV+O2Xgy/45zAFXb988V7cvi7fWv9M9eVBN+6Xe+x5W2o/wDkChtrlf93hAAAAABJRU5ErkJggg==",
    },
    "75mm x 75mm x 3mm P/C": {
        name: "75mm SHS x 3mm P/C",
        thumbnail:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABUBAMAAAD0ee18AAAAK3RFWHRDcmVhdGlvbiBUaW1lAFRodSAzIFNlcCAyMDIwIDE3OjIwOjMxICswOTMwMZUdpAAAAAd0SU1FB+QJAwc3CMU3ACgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAEZ0FNQQAAsY8L/GEFAAAALVBMVEX///////fr7uiMjIRaWlrOzs57e3vW1s6fn5mMjIz39/fW1tYxMTGQkIwYGBBcF8mhAAAAAXRSTlMAQObYZgAABEdJREFUeNrVl81rG0cYhxVDIdBL/wR3iepUIZdMEN1DL8XVpRCK6MSL91Y1Sz8SyEWkNJcgvHiI0Gl68EAWjEhKWQdjBNuC95ychGjrpmhb9mZ6EvM39J3Z2dkPrarVMa+/JPzoxzPvO/vVaGxax3VBd3uDVIt068MYqna4gK264VjSNcOxqlrhWFdrExh3jzeA17dFg2GNcFyq1iYwtrc3gDGerIXtwA5xsCZcw+JXkL4zamgE2cvK8ACvqKr54/6jfmpdwrerkhW1BC+Ht8YwvBJmhyvCHwz8phuGtubgkxlcmj9y3rROQCHUsKgV82e0d7TvN9O0HJzK5cIZY6jn+ifu3q+hhOErCItreD+FySiOaPujfV+AjxM8EOH5RYdnCRyLYuibIagAGGiVINkBOHz0GFvf5uA4Qs7RuWgiMCGW1gKGt+EEQsjveTiOKUJPITw0buBALlZqhMYkwAST34owqKA3vgwPxSEm5xlOAstt2kH/SQJHnoLnowh9nDQxlI2DdRoWce2W/8U9BTNNxyRm0MQxthPcaAYWwbZ//Q5/lcJMw3MC5kfn0ly0gxBrz3hxn3P+mYJNxrQ2IaOIoqEwhx4QGN74gPPFlH/y+VJyUqg9P/dhixM3nNy8A+h0OstgFuns+VwMtP1g8AJbh0bzGefTaQnOwueEkDj2kONaduvuTMbmYXOJJsRD7mDnvootJ+esJTyK3Os8jRXwl9Ww6snwmo6tgsUqPQ3jDxarYN0PL/EeRXs/FeDvCt1gBZH5Rfd5NWxG0iPycuZlONOAWKkR5WD75SpniCz2xPurW4RvKRhRU3WDeVEkXzKzvQpGiDHTiy8gO07g+MLpnq6ATYF7IlqVx0rJ/FbmjARw4UWe5L0oBvi0EqaMUUYRtI7pdXqrYATnAIAhUKhQU+JL8MN0i4I1ld/JGCvg2R/ZfhYaEpa98CJzCR7qZChJir+y46jsPBukzqpfFHnMFObiTNaeFJ0HD1NY4VR9SgyzbZzmNz//54nuhqcwpOA4dlqnuaNqyofZuBGVSMRgmZ6YCgN4MctrnGWwnDdMBaVGAgZGw4fK2empbBZrF5TAs5TmXQXvKlr1jqIsGahEnGMFv/NVp2cqFSFDZRtbxdY1FdzY+rOjvGEyqjFlOEjhRuPuriNhsZ2kOO0ZGp6BOm+eZVfZDxNamIs9TZGTS15wfvl9/oKvxZNl5mE4718aVuHuYOug44gDzBR7KRmKZj/1m6R0K/GLEhfa1PElDLZ88dQfW+5xEW78LDsuPKipFgjs6x8Mo19xu/TubVCBAwem3hMagPJ7/o5VcZd3BX4OpArAoCHQy30/IIfJ/5brJtDAop6Ev/aNwD1rrKyru3KcYj//e+4H7v/fUW/92OmhtnPj5d++v0P2G2sKht92xoaxV+O2Xgy/45zAFXb988V7cvi7fWv9M9eVBN+6Xe+x5W2o/wDkChtrlf93hAAAAABJRU5ErkJggg==",
    },
    "65mm x 65mm x 3mm P/C": {
        name: "65mm SHS x 3mm P/C",
        thumbnail:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABUBAMAAAD0ee18AAAAK3RFWHRDcmVhdGlvbiBUaW1lAFRodSAzIFNlcCAyMDIwIDE3OjIwOjMxICswOTMwMZUdpAAAAAd0SU1FB+QJAwc3CMU3ACgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAEZ0FNQQAAsY8L/GEFAAAALVBMVEX///////fr7uiMjIRaWlrOzs57e3vW1s6fn5mMjIz39/fW1tYxMTGQkIwYGBBcF8mhAAAAAXRSTlMAQObYZgAABEdJREFUeNrVl81rG0cYhxVDIdBL/wR3iepUIZdMEN1DL8XVpRCK6MSL91Y1Sz8SyEWkNJcgvHiI0Gl68EAWjEhKWQdjBNuC95ychGjrpmhb9mZ6EvM39J3Z2dkPrarVMa+/JPzoxzPvO/vVaGxax3VBd3uDVIt068MYqna4gK264VjSNcOxqlrhWFdrExh3jzeA17dFg2GNcFyq1iYwtrc3gDGerIXtwA5xsCZcw+JXkL4zamgE2cvK8ACvqKr54/6jfmpdwrerkhW1BC+Ht8YwvBJmhyvCHwz8phuGtubgkxlcmj9y3rROQCHUsKgV82e0d7TvN9O0HJzK5cIZY6jn+ifu3q+hhOErCItreD+FySiOaPujfV+AjxM8EOH5RYdnCRyLYuibIagAGGiVINkBOHz0GFvf5uA4Qs7RuWgiMCGW1gKGt+EEQsjveTiOKUJPITw0buBALlZqhMYkwAST34owqKA3vgwPxSEm5xlOAstt2kH/SQJHnoLnowh9nDQxlI2DdRoWce2W/8U9BTNNxyRm0MQxthPcaAYWwbZ//Q5/lcJMw3MC5kfn0ly0gxBrz3hxn3P+mYJNxrQ2IaOIoqEwhx4QGN74gPPFlH/y+VJyUqg9P/dhixM3nNy8A+h0OstgFuns+VwMtP1g8AJbh0bzGefTaQnOwueEkDj2kONaduvuTMbmYXOJJsRD7mDnvootJ+esJTyK3Os8jRXwl9Ww6snwmo6tgsUqPQ3jDxarYN0PL/EeRXs/FeDvCt1gBZH5Rfd5NWxG0iPycuZlONOAWKkR5WD75SpniCz2xPurW4RvKRhRU3WDeVEkXzKzvQpGiDHTiy8gO07g+MLpnq6ATYF7IlqVx0rJ/FbmjARw4UWe5L0oBvi0EqaMUUYRtI7pdXqrYATnAIAhUKhQU+JL8MN0i4I1ld/JGCvg2R/ZfhYaEpa98CJzCR7qZChJir+y46jsPBukzqpfFHnMFObiTNaeFJ0HD1NY4VR9SgyzbZzmNz//54nuhqcwpOA4dlqnuaNqyofZuBGVSMRgmZ6YCgN4MctrnGWwnDdMBaVGAgZGw4fK2empbBZrF5TAs5TmXQXvKlr1jqIsGahEnGMFv/NVp2cqFSFDZRtbxdY1FdzY+rOjvGEyqjFlOEjhRuPuriNhsZ2kOO0ZGp6BOm+eZVfZDxNamIs9TZGTS15wfvl9/oKvxZNl5mE4718aVuHuYOug44gDzBR7KRmKZj/1m6R0K/GLEhfa1PElDLZ88dQfW+5xEW78LDsuPKipFgjs6x8Mo19xu/TubVCBAwem3hMagPJ7/o5VcZd3BX4OpArAoCHQy30/IIfJ/5brJtDAop6Ev/aNwD1rrKyru3KcYj//e+4H7v/fUW/92OmhtnPj5d++v0P2G2sKht92xoaxV+O2Xgy/45zAFXb988V7cvi7fWv9M9eVBN+6Xe+x5W2o/wDkChtrlf93hAAAAABJRU5ErkJggg==",
    },
};

export const Centenary_Beam_Colours_Array = [
    "Classic Cream",
    "Gully",
    "Mangrove",
    "Monument",
    "Paperbark",
    "Surfmist",
    "Wallaby",
    "Woodland Grey",
];

export const validationSchema = {
    id: null,
    UserID: {
        Type: "UpperCaseLettersOnly",
        Regex: "[A-Z]+",
        Descriptor: "",
        IsRequired: true,
        MinChars: -1,
        MaxChars: 5,
        Conditions: null,
        DefaultValue: "",
    },
    Customer: {
        JobName: {
            Type: "Name",
            Regex: "^[-0-9A-Za-z/' ]*$",
            Descriptor: "error: alphanumeric only or '-. characters",
            IsRequired: true,
            MinChars: -2147483648,
            MaxChars: 2147483647,
            Conditions: null,
            DefaultValue: "",
        },
        FirstName: {
            Type: "Name",
            Regex: "^[-0-9A-Za-z/' ]*$",
            Descriptor: "error: alphanumeric only or '-. characters",
            IsRequired: false,
            MinChars: -2147483648,
            MaxChars: 2147483647,
            Conditions: null,
            DefaultValue: "",
        },
        LastName: {
            Type: "Name",
            Regex: "^[-0-9A-Za-z/' ]*$",
            Descriptor: "error: alphanumeric only or '-. characters",
            IsRequired: false,
            MinChars: -2147483648,
            MaxChars: 2147483647,
            Conditions: null,
            DefaultValue: "",
        },
        Phone: {
            Type: "Phone",
            Regex: "^\\({0,1}((0|\\+61)(2|4|3|7|8)){0,1}\\){0,1}(\\ |-){0,1}[0-9]{2}(\\ |-){0,1}[0-9]{2}(\\ |-){0,1}[0-9]{1}(\\ |-){0,1}[0-9]{3}$",
            Descriptor: "format: '08 XXXX XXXX' or '040X XXX XXX'",
            IsRequired: false,
            MinChars: -1,
            MaxChars: 14,
            Conditions: null,
            DefaultValue: "",
        },
        Email: {
            Type: "Email",
            Regex: '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
            Descriptor: "email format is not valid",
            IsRequired: false,
            MinChars: -2147483648,
            MaxChars: 2147483647,
            Conditions: null,
            DefaultValue: "",
        },
        Address: {
            FormattedAddress: "",
            StreetNumber: {
                Type: "AlphaNumeric",
                Regex: "^[-0-9A-Za-z/' ]*$",
                Descriptor: "",
                IsRequired: false,
                MinChars: -1,
                MaxChars: 10,
                Conditions: null,
                DefaultValue: "",
            },
            Street: {
                Type: "AlphaNumeric",
                Regex: "^[-0-9A-Za-z/' ]*$",
                Descriptor: "",
                IsRequired: false,
                MinChars: -2147483648,
                MaxChars: 2147483647,
                Conditions: null,
                DefaultValue: "",
            },
            Suburb: {
                Type: "AlphaNumeric",
                Regex: "^[-0-9A-Za-z/' ]*$",
                Descriptor: "",
                IsRequired: false,
                MinChars: -2147483648,
                MaxChars: 2147483647,
                Conditions: null,
                DefaultValue: "",
            },
            State: {
                Type: "AlphaNumeric",
                Regex: "^[-0-9A-Za-z/' ]*$",
                Descriptor: "",
                IsRequired: false,
                MinChars: -2147483648,
                MaxChars: 2147483647,
                Conditions: null,
                DefaultValue: "",
            },
            PostCode: {
                Type: "IntergersOnly",
                Regex: "^[0-9]*$",
                Descriptor: "",
                IsRequired: false,
                MinChars: 4,
                MaxChars: 4,
                Conditions: null,
                DefaultValue: "",
            },
            LatLng: {
                lat: 0.0,
                lng: 0.0,
            },
        },
    },
    Distributor: {
        Name: null,
        Code: null,
        ABN: null,
        BuildingLicence: null,
        Email: null,
        Phone: null,
        Logo: null,
        Address: null,
    },
    SiteParameters: {
        UseType: {
            Type: "None",
            Regex: "",
            Descriptor: "",
            IsRequired: false,
            MinChars: -1,
            MaxChars: -1,
            ValidOptions: ["Domestic", "Commercial"],
            Conditions: null,
            DefaultValue: "Domestic",
        },
        Blocking: {
            Type: "IntergersOnly",
            Regex: "^[0-9]*$",
            Descriptor: "",
            IsRequired: true,
            MinChars: 0,
            MaxChars: 4,
            Conditions: null,
            DefaultValue: "",
        },
        Address: {
            FormattedAddress: {
                Type: "None",
                Regex: "",
                Descriptor: "Site Address is required",
                IsRequired: true,
                MinChars: -2147483648,
                MaxChars: 2147483647,
                Conditions: null,
                DefaultValue: "",
            },
            StreetNumber: {
                Type: "AlphaNumeric",
                Regex: "^[-0-9A-Za-z/' ]*$",
                Descriptor: "",
                IsRequired: false,
                MinChars: -1,
                MaxChars: 10,
                Conditions: null,
                DefaultValue: "",
            },
            Street: {
                Type: "AlphaNumeric",
                Regex: "^[-0-9A-Za-z/' ]*$",
                Descriptor: "",
                IsRequired: false,
                MinChars: -2147483648,
                MaxChars: 2147483647,
                Conditions: null,
                DefaultValue: "",
            },
            Suburb: {
                Type: "AlphaNumeric",
                Regex: "^[-0-9A-Za-z/' ]*$",
                Descriptor: "",
                IsRequired: false,
                MinChars: -2147483648,
                MaxChars: 2147483647,
                Conditions: null,
                DefaultValue: "",
            },
            State: {
                Type: "AlphaNumeric",
                Regex: "^[-0-9A-Za-z/' ]*$",
                Descriptor: "",
                IsRequired: false,
                MinChars: -2147483648,
                MaxChars: 2147483647,
                Conditions: null,
                DefaultValue: "",
            },
            PostCode: {
                Type: "IntergersOnly",
                Regex: "^[0-9]*$",
                Descriptor: "",
                IsRequired: false,
                MinChars: 4,
                MaxChars: 4,
                Conditions: null,
                DefaultValue: "",
            },
            LatLng: {
                lat: 0.0,
                lng: 0.0,
            },
        },
        ExistingStructure: {
            AttachmentMethod: null,
            RoofPitch: {
                Type: "Decimal",
                Regex: "^[0-9]+([,.][0-9]+)?$",
                Descriptor: "Roof Pitch must be numbers only or decimal",
                IsRequired: false,
                MinChars: -2147483648,
                MaxChars: 2147483647,
                ValidOptions: [0, 15, 17.5, 20, 22.5, 25, 27.5, 30],
                Conditions: null,
                DefaultValue: 22.5,
            },
            RoofType: {
                Type: "None",
                Regex: "",
                Descriptor: "",
                IsRequired: false,
                MinChars: -2147483648,
                MaxChars: 2147483647,
                ValidOptions: [
                    {
                        Key: "Sheet",
                        Display: "Sheet Steel",
                    },
                    {
                        Key: "Tile",
                        Display: "Tile",
                    },
                ],
                Conditions: null,
                DefaultValue: "Sheet",
            },
            RoofColour: null,
            FasciaType: null,
            FasciaMaterial: {
                Type: "None",
                Regex: "",
                Descriptor: "",
                IsRequired: false,
                MinChars: -2147483648,
                MaxChars: 2147483647,
                ValidOptions: [
                    {
                        Key: "Timber",
                        Display: "Timber",
                    },
                    {
                        Key: "Steel",
                        Display: "Steel",
                    },
                ],
                Conditions: null,
                DefaultValue: "Timber",
            },
            FasciaHeight: null,
            WallHeight: null,
            EaveDepth: null,
            CladdingWidth: null,
            WallType: null,
            FrameType: null,
            WallColour: null,
            GutterOffset: null,
            GutterWidth: null,
            FloorType: null,
            FloorColour: null,
        },
    },
    AreaSpecifications: [
        {
            SHAPE: {
                DesignType: null,
                DesignSubType: null,
                Length: {
                    Type: "IntergersOnly",
                    Regex: "^[0-9]*$",
                    Descriptor: "must be numbers only",
                    IsRequired: false,
                    MinChars: 200,
                    MaxChars: 20000,
                    Conditions: null,
                    DefaultValue: 6000,
                },
                Depth: {
                    Type: "IntergersOnly",
                    Regex: "^[0-9]*$",
                    Descriptor: "must be numbers only",
                    IsRequired: false,
                    MinChars: 200,
                    MaxChars: 12000,
                    Conditions: null,
                    DefaultValue: 3000,
                },
                Height: null,
                RoofPitch: [
                    {
                        Type: "Decimal",
                        Regex: "^[0-9]+([,.][0-9]+)?$",
                        Descriptor: "must be numbers only",
                        IsRequired: false,
                        MinChars: 15,
                        MaxChars: 30,
                        ValidOptions: [15, 20, 25, 30],
                        Conditions: {
                            DesignType: "Gable Hip Roof",
                        },
                        DefaultValue: 20,
                    },
                    {
                        Type: "Decimal",
                        Regex: "^[0-9]+([,.][0-9]+)?$",
                        Descriptor: "must be numbers only",
                        IsRequired: false,
                        MinChars: "Area.RoofSheetData.MinRoofPitch",
                        MaxChars: 30,
                        Conditions: null,
                        DefaultValue: 2,
                    },
                ],
                SheetDirection: null,
            },
            ROOF_SHEETING: null,
        },
    ],
    RawData: null,
};

export const initialState = null;

// export const initialState = {
//     RoofSheetTypes: {
//         "Cent 310 Deck" : {
//             [ROOFSHEET_TYPE.NAME] : "Cent 310 Deck",
//             [ROOFSHEET_TYPE.SUBTYPES]: {
//                 "Colorbond 0.42": {
//                     RoofSheetID: "Cent 310 Deck"
//                 },
//             },
//             [ROOFSHEET_TYPE.DEFAULT_SUBTYPE]: "Colorbond 0.42",
//             [ROOFSHEET_TYPE.DEFAULT_COLOUR]: "Classic Cream",
//             [ROOFSHEET_TYPE.THUMBNAIL]: "data:image/png;base64,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",
//             [ROOFSHEET_TYPE.TEXTURE_FILENAME] : "ZMM_CDECK.PNG",
//             [ROOFSHEET_TYPE.TEXTURE_NORMAL_FILENAME] : "ZMM_CDECK_NORMAL.PNG",
//         },
//         "Hi-Rib": {
//             [ROOFSHEET_TYPE.NAME] : "Hi-Rib",
//             [ROOFSHEET_TYPE.SUBTYPES]: {
//                 "Alsynite Ultra 8oz": {
//                     RoofSheetID: "Hirib Alsynite Ultra 8oz"
//                 },
//                 "Colorbond 0.42 (No Foot Traffic)": {
//                     RoofSheetID: "Hirib 0.42 G550 - C/Bond (No Foot Traffic)"
//                 },
//                 "Colorbond 0.42 (Non-Trafficable)": {
//                     RoofSheetID: "Hirib 0.42 G550 - C/Bond (Non-Trafficable)"
//                 },
//             },
//                 // "Colorbond 0.42 (No Foot Traffic)","Colorbond 0.42 (Non-Trafficable)","Polycarbonate","Zinc 0.42 (No Foot Traffic)","Zinc 0.42 (Non-Trafficable)"
//             // },
//             [ROOFSHEET_TYPE.DEFAULT_SUBTYPE]: "Colorbond 0.42 (No Foot Traffic)",
//             [ROOFSHEET_TYPE.DEFAULT_COLOUR]: "Classic Cream",
//             [ROOFSHEET_TYPE.THUMBNAIL]: "data:image/png;base64,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",
//             [ROOFSHEET_TYPE.TEXTURE_FILENAME] : "ZMM_HIDECK.PNG",
//             [ROOFSHEET_TYPE.TEXTURE_NORMAL_FILENAME] : "ZMM_HIDECK_NORMAL.PNG",
//         },
//         "Hi-Rib": {
//             [ROOFSHEET_TYPE.NAME] : "Hi-Rib",
//             [ROOFSHEET_TYPE.SUBTYPES]: {
//                 "Alsynite Ultra 8oz": {
//                     RoofSheetID: "Hirib Alsynite Ultra 8oz",
//                     MinPitch: 1,
//                     ColourArrayIndex: 37,
//                 },
//                 "Colorbond 0.42 (No Foot Traffic)": {
//                     RoofSheetID: "Hirib 0.42 G550 - C/Bond (No Foot Traffic)"
//                 },
//                 "Colorbond 0.42 (Non-Trafficable)": {
//                     RoofSheetID: "Hirib 0.42 G550 - C/Bond (Non-Trafficable)"
//                 },
//             },
//                 // "Colorbond 0.42 (No Foot Traffic)","Colorbond 0.42 (Non-Trafficable)","Polycarbonate","Zinc 0.42 (No Foot Traffic)","Zinc 0.42 (Non-Trafficable)"
//             // },
//             [ROOFSHEET_TYPE.DEFAULT_SUBTYPE]: "Colorbond 0.42 (No Foot Traffic)",
//             [ROOFSHEET_TYPE.DEFAULT_COLOUR]: "Classic Cream",
//             [ROOFSHEET_TYPE.THUMBNAIL]: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAS0AAABdCAYAAADwtjCbAAAAB3RJTUUH4wQBAyg1GJDW+QAAAAlwSFlzAAAK8AAACvABQqw0mAAAAARnQU1BAACxjwv8YQUAAAhmSURBVHja7d3BcdtGFIDhTcaH3JwOrNxy4UipQEwFZioQxAYs33ITdcrRdgMW1IFcQagKIo0LiNyB3UHw8uAh9bBLEsAuFhT/bwaaISiCIBZ4u/uwAJwDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgE1+yPKtk/m0+ivTUT2J+2p6rKal+/zxPvN2gc9kfuJW5Xay9o6U11enZbfMvZrYwH/sPdbT7T4ce8MFrcn85+rvRT293PLfX6ppUW3AMtuWgVqVW1FNr3b4xLdqKqvpfVV+j7lXH67LsVc6Lb+vuVfdZ5igNZnP6g2xbYNZsgELau9MupebkOAlO/4i9884aN3LUMpPjr3b3D/BSh+0JvOy+nvWcylX7PwDi1Nu4q6aZmOttZ+1yXxR/b3suZSbquyK3D9lXdqgtXnH/+Q0FyKTNF+PnOzczh0H/n90G+/Z2lxuD05yH5rDkrI7qqdpNZ1u+MyUwDWguMfeqMovXdAKb7Qbp/mqx8Dnpv+/7z8ACFyphWvnzeWmnz1ymjd543n3ofrsiUN6k7mUwTvPO9uOvSMnXXrnXnvevas+N83900SaoOXf8dv1kcMbnq5iKrrT/mvmts9t6FlG+X+buKfsUtNK/28zV8rwYucTW+E82IdqGRe5f2L8oKU77D9mrmy0aevTqVoAsvPbjfc7yfkE/K3j3zqdBtczVkvX7HL8wlnFhCbzR9esLNqXoR7HS9c89v7InZz/McEy33vmzTrt+BqYZp53yqRb5RBpkLEB66rzuB3NfxROK6x1i9w/9dnS3okNWOcdjz35zNQ1y+9962VFFjdoaffC5qKuerWK9LNvzdxXdU2AeGzloEMW+tAdf2HmntUBEvEV5vVdr7GOWn52mXLsFe0XFk/slpb9MV+i5DA+f5SD52HLd6EfG7Ruo5wt0rKztXWR+8c+O9pgsF3x/vkn7QremblFzp+aOmiVEZdtlzWNvO6Hbmpex8xb2GUVuX/sM2QrnYeIl+QszOvTnD2deEFLf4TtT5cR19Xu+Md17YK+9ISHTbguI36D7WYe072PrjCvy2hL1hTNFzM321nEmC0t+yM+RT1LpMuyG27WYUlostvxU9SBhFrj2+599lPnz4a/axj7DN/CvM6Wm4wTtLTWbOZE4rPLvCCp25Pu8IWZu0zwTaV5PaO1FY1tyd4lGFYix57NTWapePoHLQ0apXvavfiW6A4NdpnSHV0m2TKHQMvONw4uRYVTmtcv//8eKp1+9EyeHcFeRv8ebXnb5V7WqYVBxWhpSZS3TdOyw3K283czjutBkWjPV3Y3SQZ/6k7fHLqSJkAeBg0Y12autIZSbVPfEJjboVvM/YKWRnk7IPEh8VD/qWvmts7qS4ewK91ezbJL2eTX4Q83Zu4pZdeBdut9walIdmGzVmbnZu7gLebuQUujq428EuXTJse1QGau2b++zD3obW/otWW+a0OHuIWMBEXbWr6s1wm7CHfrr5JfYqNpnw9mrqZpBgpc3YKWP48likGuK9Nuom8nvya5u4Vun9Lzzmygsgtd3lMyhGVnoW79YpBv156UbTHL+pRDfH3XlpZvo30Y9EJKHTty7nlnSeAKCFc254NegO6/PITE/C70+sJhu/V+vhbz6yHyy+2Dljbjh85j+fmbquz8YVKp+GrocvA10QrOlp2sW/YLckdLE+/2dk1Ddeuf0u+T9fHll4uUX90uaGnzvTRz0+exNvE3VQftY++FyVyCgb2Y/SHrTRW17Ox1bWd1awLrwon3Ybr1PuH88nXKHGXblpYv+TdMHmsTPfCaQyGotZXWfPZuolJDTnOvmvPv9O/o4q8JJ97fZr+vXDi/XKYqw92DltbUefNYm01dM3Cd1et9uHTH8Y3lGcfDJlbdDIuW8koo8T6OfdufX5YAu0xxcmW3oKVNPVtT58ljhYTPSr052KEQq7uHWhejeiinrosdePrScbXDmBLvmw2YX94etMaYxwpZ3W3Rus5xuUFWq4DlG8tT5l69Bv/A0+ODbimPKfG+i/BQiKi9se33iJ/M712zaXo+yh1/tc6F83eJ2t+n3r98KZyUXZf73t1u//3e5e4N46tsVuscuq98//3Nf2F4THGfyKzrK/vqfj0fIVyG0Z6ktTloaS1nu4X78Rgv/9N8JHAd9dq54j3EdBNZz5POJzj8v31Uz67bsO6+Byr0r3Amc1nmaefPbxfvuAgf+G9Hk8favv5SVvb+elHWP9w9nMx/db481tj60iH+7sb35GC3VtIwAev7ei46ruPU+YN1umvSYgoPPC17lJu0LlMGLHEWcWDluBPv24SHQryLkV8Ot7Qm8z+rv3+tzYnXvRqSv4aV0/2PLZckB8xxy8/0ddfhM9JS2a8uhY+/ld+l3ELbJBWp2PtUDr79bD9ayZb/GYzC7tdlm+7/iw3v/WRej+uM0+4k4i/d0x3hlWs2Xdvq/7SaJmnFrh9cMVoH+cfydCFJXe0qrm+DGOUm5CxXrABgyyx2xTbexPs2st9N5jIUwuaX7X69bLPYFzv+X55LPWKQwtbugS+p2cfuT+zdlT5o87rvYtbsT5fCT8rt0cUtt7uoQ3Umczlhsoy8jk+3Qe7B233IMaKVz5vey6rtMk5rf/JYIVroU9fsY3eV5uypLvOh72JqeS/RiSE88LSPIvI6hh5qGsN+tpIt/1CIzjbltI6cnGmTmm6fI/3T3yQRv+9Qha9Ju8mr7d7X/V52KXzilJtIV3bxym3lOQSs7/QkSuiynucTYwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAW/gMRj/LC4YhOxgAAAABJRU5ErkJggg==",
//             [ROOFSHEET_TYPE.TEXTURE_FILENAME] : "ZMM_HIDECK.PNG",
//             [ROOFSHEET_TYPE.TEXTURE_NORMAL_FILENAME] : "ZMM_HIDECK_NORMAL.PNG",
//         },
//     },
//     RoofSheets: {
//         "Cent 310 Deck": {
//             "Name": "Cent 310 Deck",
//             "Material Type": "Colorbond 0.42",
//             "MinPitch": 1,
//             "Index": 54,
//             "ColourArrayIndex": 37,
//             "RecommendedSkylightIndex": 77,
//             "DefaultRollingIndex": 3,
//             "RollingArray": 3,
//             "Category": "Cent 310 Deck",
//             "AllowedInFreespan": true,
//             "MinSupplyLength": 0,
//             "ProfileType": 2,
//             "SheetWidth": 465,
//             "SheetCoverage": 310,
//             "TextureIndex": 2,
//             "UseSkylightSpacing": 0,
//             "BackChannelAngledIndex": 7,
//             "BackChannelIndex": 3,
//             "BargeCapping": "Cent Deck Barge Capping",
//             "BargeCappingPortal": "Cent Deck Barge Capping Overhang",
//             "BargeCappingPortalOverhang": "Cent Deck Barge Capping Overhang",
//             "CoverSheetCode": null,
//             "GutterClipCode": "JSTRAP",
//             "MLSection": "0",
//             "ProductCode": "CD42<DS>",
//             "TekScrewCode": "TS1220N^TS1220NCS",
//             "TekScrewEndCode": null,
//             "Spans": {
//               "MaxInternalSpan": 4000,
//               "MaxEndSpan": 4000,
//               "MaxOverhang": 600,
//               "N3": {
//                 "MaxInternalSpan": 3700,
//                 "MaxEndSpan": 3700
//               },
//               "N4": {
//                 "MaxInternalSpan": 3400,
//                 "MaxEndSpan": 3400,
//                 "MaxOverhang": 300
//               },
//               "N5": {
//                 "MaxInternalSpan": 3100,
//                 "MaxEndSpan": 3100,
//                 "MaxOverhang": 300
//               },
//               "N6": {
//                 "MaxInternalSpan": 2800,
//                 "MaxEndSpan": 2800,
//                 "MaxOverhang": 300
//               }
//             },
//         },
//         "Hirib Alsynite Ultra 8oz": {
//             "Name": "Hirib Alsynite Ultra 8oz",
//             "Material Type": "Alsynite Ultra 8oz",
//             "MinPitch": 1,
//             "Index": 10,
//             "ColourArrayIndex": 7,
//             "RecommendedSkylightIndex": 10,
//             "DefaultRollingIndex": 2,
//             "RollingArray": 2,
//             "Category": "Hi-Rib",
//             "AllowedInFreespan": true,
//             "MinSupplyLength": 0,
//             "ProfileType": 2,
//             "SheetWidth": 750,
//             "SheetCoverage": 650,
//             "TextureIndex": 2,
//             "UseSkylightSpacing": 0,
//             "BackChannelAngledIndex": 7,
//             "BackChannelIndex": 3,
//             "BargeCapping": "Cent Deck Barge Capping",
//             "BargeCappingPortal": "Cent Deck Barge Capping Overhang",
//             "BargeCappingPortalOverhang": "Cent Deck Barge Capping Overhang",
//             "CoverSheetCode": "HICOVER",
//             "GutterClipCode": "JSTRAP",
//             "MLSection": "1",
//             "ProductCode": "FI8HI",
//             "TekScrewCode": "TS1220N^TS1220NCS",
//             "TekScrewEndCode": null,
//             "Spans": {
//               "MaxInternalSpan": 3500,
//               "MaxEndSpan": 3500,
//               "MaxOverhang": 650,
//               "N1": {
//                 "MaxInternalSpan": 3900,
//                 "MaxEndSpan": 3900,
//                 "MaxOverhang": 900
//               },
//               "N3": {
//                 "MaxInternalSpan": 3100,
//                 "MaxEndSpan": 3100
//               },
//               "N4": {
//                 "MaxInternalSpan": 3100,
//                 "MaxEndSpan": 3100
//               },
//               "N5": {
//                 "MaxInternalSpan": 3100,
//                 "MaxEndSpan": 3100
//               },
//               "N6": {
//                 "MaxInternalSpan": 3100,
//                 "MaxEndSpan": 3100
//               }
//             }
//         },
//         "Hirib 0.42 G550 - C/Bond (No Foot Traffic)": {
//             "Name": "Hirib 0.42 G550 - C/Bond (No Foot Traffic)",
//             "Material Type": "Colorbond 0.42 (No Foot Traffic)",
//             "MinPitch": 1,
//             "Index": 7,
//             "ColourArrayIndex": 25,
//             "RecommendedSkylightIndex": 10,
//             "DefaultRollingIndex": 2,
//             "RollingArray": 2,
//             "Category": "Hi Rib",
//             "AllowedInFreespan": true,
//             "MinSupplyLength": 0,
//             "ProfileType": 2,
//             "SheetWidth": 750,
//             "SheetCoverage": 680,
//             "TextureIndex": 2,
//             "UseSkylightSpacing": 0,
//             "BackChannelAngledIndex": 7,
//             "BackChannelIndex": 3,
//             "BargeCapping": "Cent Deck Barge Capping",
//             "BargeCappingPortal": "Cent Deck Barge Capping Overhang",
//             "BargeCappingPortalOverhang": "Cent Deck Barge Capping Overhang",
//             "CoverSheetCode": "HICOVER",
//             "GutterClipCode": "JSTRAP",
//             "MLSection": "0",
//             "ProductCode": "HI42<DS>",
//             "TekScrewCode": "TS1220N^TS1220NCS",
//             "TekScrewEndCode": null,
//             "Spans": {
//               "MaxInternalSpan": 3500,
//               "MaxEndSpan": 3500,
//               "MaxOverhang": 650,
//               "N1": {
//                 "MaxInternalSpan": 3900,
//                 "MaxEndSpan": 3900,
//                 "MaxOverhang": 900
//               },
//               "N3": {
//                 "MaxInternalSpan": 3100,
//                 "MaxEndSpan": 3100
//               },
//               "N4": {
//                 "MaxInternalSpan": 3100,
//                 "MaxEndSpan": 3100
//               },
//               "N5": {
//                 "MaxInternalSpan": 3100,
//                 "MaxEndSpan": 3100
//               },
//               "N6": {
//                 "MaxInternalSpan": 3100,
//                 "MaxEndSpan": 3100
//               }
//             }
//         },
//         "Hirib 0.42 G550 - C/Bond (Non-Trafficable)": {
//             "Name": "Hirib 0.42 G550 - C/Bond (Non-Trafficable)",
//             "Material Type": "Colorbond 0.42 (Non-Trafficable)",
//             "MinPitch": 1,
//             "Index": 41,
//             "ColourArrayIndex": 25,
//             "RecommendedSkylightIndex": 10,
//             "DefaultRollingIndex": 2,
//             "RollingArray": 2,
//             "Category": "Hi Rib",
//             "AllowedInFreespan": true,
//             "MinSupplyLength": 0,
//             "ProfileType": 2,
//             "SheetWidth": 750,
//             "SheetCoverage": 680,
//             "TextureIndex": 2,
//             "UseSkylightSpacing": 0,
//             "BackChannelAngledIndex": 7,
//             "BackChannelIndex": 3,
//             "BargeCapping": "Cent Deck Barge Capping",
//             "BargeCappingPortal": "Cent Deck Barge Capping Overhang",
//             "BargeCappingPortalOverhang": "Cent Deck Barge Capping Overhang",
//             "CoverSheetCode": "HICOVER",
//             "GutterClipCode": "JSTRAP",
//             "MLSection": "0",
//             "ProductCode": "HI42<DS>",
//             "TekScrewCode": "TS1220N^TS1220NCS",
//             "TekScrewEndCode": null,
//             "Spans": {
//               "MaxInternalSpan": 3400,
//               "MaxEndSpan": 2300,
//               "MaxOverhang": 250
//             }
//         },
//     }
// }

export const testState = {
    design_types: ["Flat", "Pitched", "Portal"],
    Flat: {
        length_range: {
            min: 300,
            max: 20000,
            default: 6000,
        },
        projection_range: {
            min: 300,
            max: 10000,
            default: 3000,
        },
        height_range: {
            min: 2100,
            max: 3600,
            default: 2400,
        },
        pitch_range: {
            min: 1,
            max: 3600,
            default: 1,
        },
        overhang_left_range: {
            min: 0,
            max: 500,
            default: 0,
        },
        overhang_right_range: {
            min: 0,
            max: 500,
            default: 0,
        },
        overhang_front_range: {
            min: 0,
            max: "MAX_SHEET_OVERHANG",
            default: 0,
        },
        overhang_back_range: {
            min: 0,
            max: "MAX_SHEET_OVERHANG",
            default: 0,
        },
        overhang_cutout_range: {
            min: 0,
            max: "MAX_SHEET_OVERHANG",
            default: 0,
        },
        roofsheet_groups: ["Cent 310 Deck", "Corrugated", "Hi-Rib", "TL5", "Polycarbonate", "Solarspan"],
        roofsheet_default: "Cent 310 Deck",
        gutter_options: [
            "Fascia Gutter",
            "D Gutter",
            "OG Gutter",
            "Hi Front Quad Gutter",
            "Quad Gutter",
            "Hi Ten OG Gutter (QOG)",
        ],
        gutter_default: "Hi Front Quad Gutter",
        downpipe_options: [
            "65mm Square Downpipe",
            "75mm Round Downpipe (PVC)",
            "90mm Round Downpipe (PVC)",
            "100mm x 50mm Square Downpipe",
            "100mm x 75mm Square Downpipe",
        ],
        downpipe_default: "65mm Square Downpipe",
        post_options: ["Box", "RHS/SHS"],
        post_type_default: "Box",
        post_section_default: "656508",
        beam_purlin_options: ["Box", "RHS/SHS"],
        beam_purlin_type_default: "Box",
        beam_purlin_section_default: "1586510",
        beam_rafter_options: ["Rafter Box", "RHS/SHS"],
        beam_rafter_type_default: "Box",
        beam_rafter_section_default: "1586510",
        beam_fascia_options: ["Fascia Box", "RHS/SHS"],
        beam_fascia_type_default: "Box",
        beam_fascia_section_default: "1586510",
        allow_omit_side_beams: 1,
        allow_slats: 1,
        post_must_be_shs_in_freestanding: 1,
    },
    Pitched: {
        length_range: {
            min: 300,
            max: 8000,
        },
        projection_range: {
            min: 300,
            max: 10000,
        },
        height_range: {
            min: 2100,
            max: 3600,
        },
        overhang_front_range: {
            min: 0,
            max: 500,
        },
        overhang_back_range: {
            min: 0,
            max: 500,
        },
        roofsheet_groups: ["Cent 310 Deck", "Corrugated", "Hi-Rib", "TL5", "Polycarbonate", "Solarspan"],
        gutter_options: [
            "Fascia Gutter",
            "D Gutter",
            "OG Gutter",
            "Hi Front Quad Gutter",
            "Quad Gutter",
            "Hi Ten OG Gutter",
        ],
        downpipe_options: [
            "65mm Square Downpipe",
            "75mm Round Downpipe (PVC)",
            "90mm Round Downpipe (PVC)",
            "100mm x 50mm Square Downpipe",
            "100mm x 75mm Square Downpipe",
        ],
        post_options: ["Box", "RHS/SHS"],
        beam_purlin_options: ["Box", "RHS/SHS"],
        beam_rafter_options: ["Rafter Box", "RHS/SHS"],
        beam_fascia_options: ["Fascia Box", "RHS/SHS"],
        beam_pitching_options: ["Fascia Box", "RHS/SHS"],
        infill_options: [
            "None",
            "Lattice Smooth Diamond",
            "Lattice Smooth Square",
            "Plain Smooth",
            "Plain Stucco",
            "Acylic Flat",
            "Ampelite Solasafe Polycarbonate Corrugated",
            "Ampelite Solasafe Polycarbonate Greca",
            "Ampelite Solasafe Polycarbonate TL5",
            "Polycarbonate Ampelite Hr1 Corrugated",
            "Polycarbonate Ampelite Hr1 Greca",
            "Polycarbonate M-CLAD 0.8mm",
            "Corrugated - C/Bond",
            "Corrugated - Galv",
            "Corrugated - Zinc",
            "Corrugated - C/Bond D/S Gloss",
            "Corrugated - C/Bond 0.48",
            "M-CLAD 0.42",
            "M-CLAD 0.48",
            "Twin Wall 1050",
        ],
        allow_slats: 1,
    },
    roofsheet_types: {
        "Cent 310 Deck": {
            name: "Cent 310 Deck",
            subtypes: {
                "Colorbond 0.42": {
                    roofsheet_id: "Cent 310 Deck",
                    colour_array: "Cent 310 Deck",
                },
            },
            default_subtype: "Colorbond 0.42",
            default_colour: "Classic Cream",
            thumbnail:
                "data:image/png;base64,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",
            texture_filename: "ZMM_CDECK.PNG",
            texture_normal_filename: "ZMM_CDECK_NORMAL.PNG",
            min_pitch: 1,
        },
        "Hi-Rib": {
            name: "Hi-Rib",
            subtypes: {
                "Alsynite Ultra 8oz": {
                    roofsheet_id: "Hirib Alsynite Ultra 8oz",
                    colour_array_index: 37,
                },
                "Colorbond 0.42 (No Foot Traffic)": {
                    roofsheet_id: "Hirib 0.42 G550 - C/Bond (No Foot Traffic)",
                    colour_array_index: 37,
                },
                "Colorbond 0.42 (Non-Trafficable)": {
                    roofsheet_id: "Hirib 0.42 G550 - C/Bond (Non-Trafficable)",
                    colour_array_index: 37,
                },
            },
            default_subtype: "Colorbond 0.42 (No Foot Traffic)",
            default_colour: "Classic Cream",
            thumbnail:
                "data:image/png;base64,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",
            texture_filename: "ZMM_HIDECK.PNG",
            texture_normal_filename: "ZMM_HIDECK_NORMAL.PNG",
            min_pitch: 1,
        },
    },
    gutter_types: {
        "Fascia Gutter": {
            name: "Fascia Gutter",
            colour_array: "Colorbond & Zincalume",
            easy_fix_allowed: 0,
        },
        "D Gutter": {
            name: "D Gutter",
            colour_array: "Colorbond & Zincalume",
            easy_fix_allowed: 0,
        },
        "OG Gutter": {
            name: "OG Gutter",
            colour_array: "Colorbond & Zincalume",
            easy_fix_allowed: 1,
            easy_fix_preferred: 1,
        },
        "Hi Front Quad Gutter": {
            name: "Hi Front Quad Gutter",
            colour_array: "Colorbond & Zincalume",
            easy_fix_allowed: 1,
            easy_fix_preferred: 1,
        },
        "Quad Gutter": {
            name: "Quad Gutter",
            colour_array: "Colorbond & Zincalume",
            easy_fix_allowed: 1,
            easy_fix_preferred: 1,
        },
        "Hi Ten OG Gutter": {
            name: "Hi Ten OG Gutter",
            colour_array: "Colorbond & Zincalume",
            easy_fix_allowed: 0,
        },
    },
    colour_arrays: {
        "Cent 310 Deck": [
            "Classic Cream/Classic Cream",
            "Classic Cream/Mangrove",
            "Classic Cream/Monument",
            "Classic Cream/Woodland Grey",
            "Paperbark/Gully",
            "Paperbark/Paperbark",
            "Paperbark/Woodland Grey",
            "Surfmist/Monument",
            "Surfmist/Surfmist",
        ],
        Colorbond: ["Classic Cream", "Basalt", "..."],
        ColorbondPlusZinc: ["Classic Cream", "Basalt", "...", "Zincalume"],
    },
    validationSchema: validationSchema,
};

export const pricing_data_template = {
    overall_markup: 1.17432,
    area_pricing: {
        0: 1.17432,
    },
    fielders_material_markup_factor: 2.31,
    fielders_material_markup_factor_type: "Dist 0",
    fielders_material_discount_factor: 0.0,
    fielders_material_markup_overall: 2.31,
    fielders_pricing_factors: {
        FIELDERS: 1.0,
        CURVED: 1.0,
        DECK: 0.78,
        "CARPORT HIP": 0.89,
        "PITCHED FREESPAN": 1.0,
        RHS: 0.75,
        FLAT: 1.0,
        CDECKPOLYCARB: 0.7155,
        POLYCARB: 1.06,
        SOLARSPAN: 1.0,
        SLATS: 1.7,
        PITCHED: 1.0,
        "BBQ SHELTER": 1.06,
        "PITCHED FREESTANDING": 1.0,
        "FLAT FREESTANDING": 1.0,
        "CARPORT GAZEBO": 1.0,
        ALL: 1.17432,
        "CARPORT T-JUNCTION": 1.0,
        "GALV FLAT": 0.6658,
        "CARPORT JUNCTION": 1.0,
        "CARPORT FREESTANDING": 0.99,
        "CARPORT FREESPAN": 1.09,
        "CARPORT POLYCARBONATE": 0.96,
        INFILLS: 1.0,
        "CARPORT DUTCH GABLE": 0.89,
        "PITCHED SLIMLINE": 1.0,
        "FLAT POLYCARBONATE": 1.0,
        FREESTANDING: 1.0,
        "PITCHED POLYCARBONATE": 1.0,
        HARDWARE: 1.09,
        SWAGE: 0.85,
        BUYINS: 0.5,
        "CANTILEVER ROOF": 1.03,
    },
    promotion_Factor: 1.0,
};

export const fielders_cust_types = [
    { id: "1", name: "Cost", factor: "1", factor_carport: "1" },
    { id: "2", name: "Dist 0", factor: "2.31", factor_carport: "2.31" },
    { id: "3", name: "Dist 0.125", factor: "2.40", factor_carport: "2.40" },
    { id: "4", name: "Dist 0.25", factor: "2.47", factor_carport: "2.47" },
    { id: "5", name: "Dist 0.5", factor: "2.60", factor_carport: "2.60" },
    { id: "6", name: "Dist 1", factor: "2.68", factor_carport: "2.68" },
    { id: "7", name: "Dist 1.5", factor: "3.00", factor_carport: "3.00" },
    { id: "8", name: "Dist 2", factor: "3.16", factor_carport: "3.16" },
    { id: "9", name: "Dist 3", factor: "3.20", factor_carport: "3.20" },
    { id: "10", name: "Trade", factor: "3.63", factor_carport: "3.44" },
    { id: "11", name: "Retail", factor: "4.05", factor_carport: "4.05" },
];

export const special_factors_default = [
    {
        id: "1",
        name: "CARPORT FREESTANDING",
        code: "cPfs",
        factor: "0.96",
        applies_to: "",
        test_factor: "1",
        SA_factors: "0.99",
        VIC_factors: "0.96",
        NSW_factors: "0.96",
        QLD_factors: "0.96",
        WA_factors: "0.96",
        TAS_factors: "0.96",
        NT_factors: "0.97",
        state_filter: "",
    },
    {
        id: "2",
        name: "CARPORT FREESPAN",
        code: "cPfr",
        factor: "1.09",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1.09",
        VIC_factors: "1.09",
        NSW_factors: "1.09",
        QLD_factors: "1.09",
        WA_factors: "1.09",
        TAS_factors: "1.09",
        NT_factors: "1.09",
        state_filter: "",
    },
    {
        id: "3",
        name: "CARPORT POLYCARBONATE",
        code: "cPpo",
        factor: "0.96",
        applies_to: "",
        test_factor: "1",
        SA_factors: "0.96",
        VIC_factors: "0.96",
        NSW_factors: "0.96",
        QLD_factors: "0.96",
        WA_factors: "0.96",
        TAS_factors: "0.96",
        NT_factors: "0.96",
        state_filter: "",
    },
    {
        id: "4",
        name: "CARPORT HIP",
        code: "cPhi",
        factor: "0.88",
        applies_to: "",
        test_factor: "1",
        SA_factors: "0.89",
        VIC_factors: "0.88",
        NSW_factors: "0.88",
        QLD_factors: "0.88",
        WA_factors: "0.88",
        TAS_factors: "0.88",
        NT_factors: "0.88",
        state_filter: "",
    },
    {
        id: "5",
        name: "CARPORT DUTCH GABLE",
        code: "cPdu",
        factor: "0.88",
        applies_to: "",
        test_factor: "1",
        SA_factors: "0.89",
        VIC_factors: "0.88",
        NSW_factors: "0.88",
        QLD_factors: "0.88",
        WA_factors: "0.88",
        TAS_factors: "0.88",
        NT_factors: "0.88",
        state_filter: "",
    },
    {
        id: "6",
        name: "CARPORT GAZEBO",
        code: "cPga",
        factor: "1",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1",
        VIC_factors: "1",
        NSW_factors: "1",
        QLD_factors: "1",
        WA_factors: "1",
        TAS_factors: "1",
        NT_factors: "1",
        state_filter: "",
    },
    {
        id: "7",
        name: "CARPORT JUNCTION",
        code: "cPju",
        factor: "1",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1",
        VIC_factors: "1",
        NSW_factors: "1",
        QLD_factors: "1",
        WA_factors: "1",
        TAS_factors: "1",
        NT_factors: "1",
        state_filter: "",
    },
    {
        id: "8",
        name: "CARPORT T-JUNCTION",
        code: "cPtj",
        factor: "1",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1",
        VIC_factors: "1",
        NSW_factors: "1",
        QLD_factors: "1",
        WA_factors: "1",
        TAS_factors: "1",
        NT_factors: "1",
        state_filter: "",
    },
    {
        id: "9",
        name: "GALV FLAT",
        code: "verGal",
        factor: "1",
        applies_to: "",
        test_factor: "0.6658",
        SA_factors: "0.6658",
        VIC_factors: "1",
        NSW_factors: "1",
        QLD_factors: "1",
        WA_factors: "1",
        TAS_factors: "1",
        NT_factors: "1",
        state_filter: "",
    },
    {
        id: "10",
        name: "FLAT",
        code: "verFlt",
        factor: "1",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1",
        VIC_factors: "1",
        NSW_factors: "1",
        QLD_factors: "1",
        WA_factors: "1",
        TAS_factors: "1",
        NT_factors: "1",
        state_filter: "",
    },
    {
        id: "11",
        name: "PITCHED",
        code: "verPit",
        factor: "1",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1",
        VIC_factors: "1",
        NSW_factors: "1",
        QLD_factors: "1",
        WA_factors: "1",
        TAS_factors: "1",
        NT_factors: "1",
        state_filter: "",
    },
    {
        id: "12",
        name: "MATERIALS - FIELDERS",
        code: "priFIE",
        factor: "1",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1",
        VIC_factors: "1",
        NSW_factors: "1",
        QLD_factors: "1",
        WA_factors: "1",
        TAS_factors: "1",
        NT_factors: "1",
        state_filter: "",
    },
    {
        id: "13",
        name: "MATERIALS - RHS",
        code: "priRHS",
        factor: "1",
        applies_to: "",
        test_factor: "1",
        SA_factors: "0.75",
        VIC_factors: "0.75",
        NSW_factors: "0.75",
        QLD_factors: "0.75",
        WA_factors: "0.75",
        TAS_factors: "0.75",
        NT_factors: "0.75",
        state_filter: "",
    },
    {
        id: "14",
        name: "MATERIALS - SWAGE",
        code: "priSWA",
        factor: "1",
        applies_to: "",
        test_factor: "1",
        SA_factors: "0.85",
        VIC_factors: "0.85",
        NSW_factors: "0.85",
        QLD_factors: "0.85",
        WA_factors: "0.85",
        TAS_factors: "0.85",
        NT_factors: "0.85",
        state_filter: "",
    },
    {
        id: "15",
        name: "MATERIALS - SLAT",
        code: "priSLA",
        factor: "1",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1.7",
        VIC_factors: "1.75",
        NSW_factors: "1.65",
        QLD_factors: "1.75",
        WA_factors: "1.75",
        TAS_factors: "1.75",
        NT_factors: "1.75",
        state_filter: "",
    },
    {
        id: "16",
        name: "MATERIALS - POLYCARBONATE",
        code: "priPOL",
        factor: "1",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1.06",
        VIC_factors: "1",
        NSW_factors: "1",
        QLD_factors: "1",
        WA_factors: "1",
        TAS_factors: "1",
        NT_factors: "1",
        state_filter: "",
    },
    {
        id: "17",
        name: "MATERIALS - C-Dek 310 POLYCARBONATE",
        code: "priCPOL",
        factor: "0.675",
        applies_to: "",
        test_factor: "1",
        SA_factors: "0.7155",
        VIC_factors: "0.675",
        NSW_factors: "0.675",
        QLD_factors: "0.675",
        WA_factors: "0.675",
        TAS_factors: "0.675",
        NT_factors: "0.675",
        state_filter: "",
    },
    {
        id: "18",
        name: "MATERIALS - INFILL",
        code: "priINF",
        factor: "1",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1",
        VIC_factors: "1",
        NSW_factors: "1",
        QLD_factors: "1",
        WA_factors: "1",
        TAS_factors: "1",
        NT_factors: "1",
        state_filter: "",
    },
    {
        id: "19",
        name: "MATERIALS - SOLARSPAN",
        code: "priSSP",
        factor: "0.65",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1",
        VIC_factors: "1",
        NSW_factors: "1",
        QLD_factors: "0.65",
        WA_factors: "1",
        TAS_factors: "1",
        NT_factors: "1",
        state_filter: "",
    },
    {
        id: "20",
        name: "MATERIALS - HARDWARE",
        code: "priHW",
        factor: "1.09",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1.09",
        VIC_factors: "1.09",
        NSW_factors: "1.09",
        QLD_factors: "1.09",
        WA_factors: "1.09",
        TAS_factors: "1.09",
        NT_factors: "1.09",
        state_filter: "",
    },
    {
        id: "21",
        name: "MATERIALS - OTHER BUY-INS",
        code: "priBUY",
        factor: "1",
        applies_to: "",
        test_factor: "1",
        SA_factors: "0.5",
        VIC_factors: "0.5",
        NSW_factors: "0.5",
        QLD_factors: "0.5",
        WA_factors: "0.5",
        TAS_factors: "0.5",
        NT_factors: "0.5",
        state_filter: "",
    },
    {
        id: "22",
        name: "OVER ALL MARKUP",
        code: "priAll",
        factor: "1.054",
        applies_to: "",
        test_factor: "1.17432",
        SA_factors: "1.17432",
        VIC_factors: "1.17432",
        NSW_factors: "1.1219",
        QLD_factors: "1.1219",
        WA_factors: "1.2897",
        TAS_factors: "1.17432",
        NT_factors: "1.17432",
        state_filter: "",
    },
    {
        id: "23",
        name: "TIMEDROP FEE ($)",
        code: "priTD",
        factor: "40",
        applies_to: "",
        test_factor: "40",
        SA_factors: "40",
        VIC_factors: "40",
        NSW_factors: "250",
        QLD_factors: "40",
        WA_factors: "40",
        TAS_factors: "40",
        NT_factors: "40",
        state_filter: "",
    },
    {
        id: "25",
        name: "CANTILEVER ROOF",
        code: "cANT",
        factor: "1.06",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1.03",
        VIC_factors: "1.06",
        NSW_factors: "1.05",
        QLD_factors: "1.06",
        WA_factors: "1.06",
        TAS_factors: "1.06",
        NT_factors: "1.06",
        state_filter: "",
    },
    {
        id: "26",
        name: "BBQ SHELTER",
        code: "bBQ",
        factor: "1.06",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1.06",
        VIC_factors: "1.06",
        NSW_factors: "1.06",
        QLD_factors: "1.06",
        WA_factors: "1.06",
        TAS_factors: "1.06",
        NT_factors: "1.06",
        state_filter: "",
    },
    {
        id: "27",
        name: "DECK",
        code: "dEK",
        factor: "0.8",
        applies_to: "",
        test_factor: "1",
        SA_factors: "0.78",
        VIC_factors: "0.8",
        NSW_factors: "0.79",
        QLD_factors: "0.8",
        WA_factors: "0.8",
        TAS_factors: "0.8",
        NT_factors: "0.8",
        state_filter: "",
    },
    {
        id: "28",
        name: "CARPORT FREESPAN - SAQ",
        code: "cPfr",
        factor: "1",
        applies_to: "XAPCAVJU",
        test_factor: "1.015",
        SA_factors: "1.015",
        VIC_factors: "1.005",
        NSW_factors: "1.015",
        QLD_factors: "1.015",
        WA_factors: "1.015",
        TAS_factors: "1.015",
        NT_factors: "1.015",
        state_filter: "SA",
    },
    {
        id: "30",
        name: "CARPORT DUTCH GABLE - SAQ",
        code: "cPdu",
        factor: "1",
        applies_to: "XAPCAVJU",
        test_factor: "1",
        SA_factors: "1",
        VIC_factors: "1",
        NSW_factors: "1",
        QLD_factors: "1",
        WA_factors: "1",
        TAS_factors: "1",
        NT_factors: "1",
        state_filter: "SA",
    },
    {
        id: "31",
        name: "CARPORT HIP - SAQ",
        code: "cPhi",
        factor: "1",
        applies_to: "XAPCAVJU",
        test_factor: "1",
        SA_factors: "1",
        VIC_factors: "1",
        NSW_factors: "1",
        QLD_factors: "1",
        WA_factors: "1",
        TAS_factors: "1",
        NT_factors: "1",
        state_filter: "SA",
    },
    {
        id: "33",
        name: "CURVED",
        code: "verCur",
        factor: "1",
        applies_to: "",
        test_factor: "1",
        SA_factors: "1",
        VIC_factors: "1",
        NSW_factors: "1",
        QLD_factors: "1",
        WA_factors: "1",
        TAS_factors: "1",
        NT_factors: "1",
        state_filter: "",
    },
];
